import Vue from 'vue'
import App from './App.vue'
import Mobile from './Mobile.vue'
import { getJsonData } from '@/common/utils/dom'

import './main.entry.scss'

const mountEl = document.querySelector('#globalHeaderApp') as HTMLElement

const install = (mountEl: HTMLElement) => {
  if (!mountEl) {
    return false
  }
  const content = window.innerWidth > 1024 ? App : Mobile

  new Vue({
    render: h => h(content, {
      props: {
        orderHistoryCount: getJsonData('#orderHistoryCount') || 0,
        currentUser: getJsonData('#currentUser') || null,
        applicationData: getJsonData('#applicationData') || undefined
      }
    })
  }).$mount(mountEl)
}

install(mountEl)
